module.exports = __webpack_public_path__ + "media/2.503ca660.mp3";